<template>
    <div>
        <buttonlist
                @help="help"
                @add="add"
                @reflash="reflash"
                @exps="exps"
                ref="SetBtn"
        ></buttonlist>
        <ul class="Boxs" ref="Box" :style="{ height: tableHeight + 'px' }">
            <li class="left1" ref="left1">
                <el-table
                        id="xpane-0"
                        :data="dataSet"
                        ref="singleTable"
                        v-loading="loading"
                        :highlight-current-row="true"
                        show-overflow-tooltip="true"
                        border
                        size="mini"
                        @row-click="editInfo"
                        :row-class-name="tableRowClassName"
                        header-row-class-name="headerclass"
                        style="width: 100%;"
                >
                    <el-table-column type="selection" v-if="false"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Name" :label="$t('getapi[8082]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="CustomMark" :label="$t('getapi[12369]')">
                        <template slot-scope="scope">
                            {{scope.row.CustomMark == 1?$t('getapi[561]'):$t('getapi[866]')}}
                        </template>
                    </el-table-column>
                </el-table>
            </li>
            <li class="resize" ref="resize">
                <i class="el-icon-caret-right" @click="leftt(0)"></i>
                <i class="el-icon-caret-left" @click="leftt(1)"></i>
            </li>
            <li class="mid1" ref="mid1">
                <!--<div class="btnnowrap">
                    <el-button type="primary"  size="mini" icon="el-icon-circle-plus" @click="addline">{{$t('getapi[878]')}}</el-button>
                </div>-->
                <el-table
                        id="xpane-1"
                        :data="dataModel"
                        ref="singleTable1"
                        v-loading="loading1"
                        :highlight-current-row="true"
                        border
                        stripe
                        size="mini"
                        :height="tableHeight"
                        header-row-class-name="headerclass"
                        style="width: 100%"
                >
                    <el-table-column type="selection" v-if="false"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Code" :label="$t('getapi[8083]')" width="200"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Name" :label="$t('getapi[1176]')" width="200"></el-table-column>
                    <el-table-column show-overflow-tooltip :label="$t('getapi[6048]')" width="100">
                        <template slot-scope="scope">
                            <el-button @click.native.prevent="edit(scope.row)" type="text" size="small">{{$t('getapi[34]')}}</el-button>
                            <el-popconfirm
                                    :confirmButtonText="$t('getapi[1146]')"
                                    :cancelButtonText="$t('getapi[2054]')"
                                    icon="el-icon-info"
                                    iconColor="red"
                                    :title="$t('getapi[6049]')"
                                    @onConfirm="del(scope.row)"
                            >
                                <el-button slot="reference" type="text" size="small">{{ $t('getapi[40]') }}</el-button>
                            </el-popconfirm>
                        </template>
                    </el-table-column>
                </el-table>
            </li>
        </ul>

        <el-dialog v-dialogDrag :visible.sync="isVisible" :title="$t('getapi[8076]')" width="50%">
            <el-row>
                <el-col :span="24">
                    <el-form :inline="true" :model="dataDetail" class="demo-form-inline" label-width="110px"
                             label-position="left" size="small">
                        <el-row>
                            <el-col :span="12">
                                <el-form-item :label="$t('getapi[8083]')">
                                    <el-input v-model="dataDetail.TemplateName"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item :label="$t('getapi[1176]')">
                                    <el-input v-model="dataDetail.descriptions"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item :label="$t('getapi[8079]')">
                                    <el-select filterable v-model="dataDetail.paper_id">
                                        <el-option v-for="item in paperArr" :key="item.Code" :label="item.Name"
                                                   :value="item.Code" size="mini"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item :label="$t('getapi[2251]')">
                                    <el-select filterable v-model="dataDetail.orientation">
                                        <el-option :label="$t('getapi[8827]')" value="landscape"></el-option>
                                        <el-option :label="$t('getapi[8828]')" value="portrait"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                </el-col>

            </el-row>
            <span slot="footer" class="dialog-footer">
				<el-button @click="isVisible = false">{{$t('getapi[2054]')}}</el-button>
				<el-button type="primary" @click="save">{{$t('getapi[937]')}}</el-button>
			</span>
        </el-dialog>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';
    import CommonHeader from '@/components/CommonHeader';
    import { Loading } from 'element-ui';
    export default {
        name: 'templateconfig',
        computed: {
            tableHeight(){
                return this.$windowSize.tableHeight-130
            }
        },
        data() {
            return {
                isVisible: false,
                userData: [], // 用户信息
                user:[],
                DbTbNames: '',
                dataSet: [], // 主表数据
                loading: false,
                loading1: false,
                dataModel: [],
                dataDetail:{
                    num:'',
                    form_key:'',
                    TemplateName:'',
                    descriptions:'',
                    create_time:'',
                    create_person:'',
                    modify_time:'',
                    modify_person:'',
                    paper_id:'',
                    paper_Name:'',
                    orientation:'landscape'
                },
                addoredit: 1,
                code: '', // 当前窗体
                paperArr: [],
                scrollTop:0,
                scrollTop1:0,
            };
        },
        beforeMount() {
            let that = this;
            that.userData = JSON.parse(sessionStorage.getItem('userData'));
            that.user = that.userData.username;
            that.$http.urlpost('/Basic/GetSysPrintPapers', '', function (res) {
                if (res.Success == 1) {
                    that.paperArr = res.DataContent;
                }
            });
        },
        watch: {
            dataSet: function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initForm(0)
                })
            },
            dataModel: function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initForm(1)
                })
            },
        },
        mounted: function () {
            let that = this;
            that.$limits.dragControllerDiv1();
            that.getView();
            that.authority();
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
                that.$refs.singleTable1.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop1 = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                    this.$refs.singleTable1.bodyWrapper.scrollTop =this.scrollTop1;
                }, 13)
            })
        },
        methods: {
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[8076]"),this.$t("getapi[12]"));
            },
            //按钮操作权限
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                //只读权
                that.$refs.SetBtn.SetButtonEnable('create,refresh,export');
            },
            tableRowClassName({ row, rowIndex }) {
                if(row.CustomMark == 1){
                    return 'green'
                }
            },
            getView(){
                let that = this;
                that.loading = true;
                that.$http.urlpost('/Basic/GetPrintFormKeys', '', function (res) {
                    if (res.Success == 1) {
                        that.dataSet = res.DataContent;
                        for(let i = 0;i<that.dataSet.length;i++){
                            if(that.dataSet[i].Code == 'pro_so_collecissue_head_iss'){
                                that.dataSet[i].CustomMark = 1
                            } else if(that.dataSet[i].Code == 'sal_ship_note_master'){
                                that.dataSet[i].CustomMark = 1
                            }  else if(that.dataSet[i].Code == 'inv_issue_manufacture'){
                                that.dataSet[i].CustomMark = 1
                            }else {
                                that.dataSet[i].CustomMark = 0
                            }
                        }
                        that.loading = false;
                    }
                });
            },
            editInfo(row){
                let that = this
                that.code = row.Code
                that.getModel( row.Code)
            },
            getModel(code){
                let that =this
                that.loading1 = true;
                let parm = {
                    Code: code
                }
                that.$http.urlpost('/Basic/GetPrintTemplates', parm, function (res) {
                    if (res.Success == 1) {
                        that.dataModel = res.DataContent;
                        that.loading1 = false;
                    }
                });
            },
            edit(row){
                let that = this
                that.addoredit = 2
                let parm = {
                    num: row.Num,
                    form_key: that.code,
                    TemplateName: row.Code
                }
                that.$http.urlpost('/Print/GetPrintTemplatesInfo', parm, function (res) {
                    if (res.Success == 1) {
                        that.dataDetail = res.DataContent;
                        that.isVisible = true
                    }
                });
            },
            add(){
                let that = this
                if(!that.code){
                    that.$message.warning(that.$t('getapi[8830]'))//'请先选择窗体！'
                    return
                }
                that.addoredit = 1
                let datetime = Common.methods.getDatetime();
                that.isVisible = true
                that.dataDetail.num = ''
                that.dataDetail.form_key = that.code
                that.dataDetail.TemplateName = ''
                that.dataDetail.descriptions = ''
                that.dataDetail.create_time = datetime
                that.dataDetail.create_person = that.user
                that.dataDetail.modify_time = ''
                that.dataDetail.modify_person = ''
                that.dataDetail.paper_id = ''
                that.dataDetail.paper_Name = ''
                that.dataDetail.orientation = 'landscape'
            },
            save(){
                let that = this
                let parm = that.dataDetail
                if(that.addoredit == 1){
                    that.$http.urlpost('/Print/InsertPrintTemplates', parm, function(res) {
                        if(res.Success == 1){
                            that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                            that.isVisible = false
                        }
                    });
                } else {
                    that.$http.urlpost('/Print/UpdatePrintTemplates', parm, function(res) {
                        if(res.Success == 1){
                            that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                            that.isVisible = false
                            that.getModel(that.code)
                        }
                    });
                }
            },
            del(row){
                let that = this
                let parm = {
                    num: row.Num,
                    form_key: that.code,
                    TemplateName: row.Code
                }
                that.$http.urlpost('/Print/DeletePrintTemplates', parm, function(res) {
                    if(res.Success == 1){
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.getModel(that.code)
                    }
                });
            },
            reflash(){
                let that = this
                if(that.code){
                    that.getModel(that.code)
                }
            },
            exps(){
                let that = this;
                let data = {
                    PageIndex: 1,
                    PageSize: 1000,
                    SelectIndex: 1,
                    Ids: '',
                    Param: [],
                    LangType:that.$processdata.getLang(),
                    fromname: that.$t('getapi[11866]')
                };
                that.$http.urlpost('/Print/ExportToExecl_PrintTemplates', data, function(res) {
                    if(res.Success == 1){
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                });
            }
        }
    };
</script>

<style scoped lang="less">
    span.title {
        width: 100%;
        display: flex;
        height: 40px;
        line-height: 40px;
    }

    span.title .el-switch {
        display: inline-block;
        margin: 8px 30px;
    }
    .box {
        width: 100%;
        overflow-x: auto;
        .bbl {
            margin: 0px auto 10px;
            white-space: pre;
            span {
                margin-left: 10px;
                min-width: 70px;
                text-align: left;
                line-height: 20px;
                display: inline-block;
                margin-right: 0px;
            }
        }
    }
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }

    /deep/ .green {
        background: #c8ffbb;
    }
    /deep/ .red {
        background: #ff7879;
    }
</style>
